import React, { Component } from "react";
import { Link } from "react-router-dom";


class AppNavbar extends Component {

  state = {
    user: {},
    isAuthenticated: false
  };

  static getDerivedStateFromProps(props) {
    const { isAuthenticated, expertid } = props;
    if (isAuthenticated && expertid) {
      return { isAuthenticated: true, expertid: expertid };
    } else {
      return { isAuthenticated: false, expertid: null };
    }
  }

  onLogoutClick = e => {
    e.preventDefault();
    this.props.parentClearUserData();
  };


  render() {
    const { isAuthenticated, expertid } = this.state;
    return (
      <nav className="navbar navbar-expand-lg navbar-light bg-light mb-4">
        <div className="container">
          <Link to="/" className="navbar-brand">
            دليل الخبراء التربويين
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarMain"
          >
            <span className="navbar-toggler-icon" />
          </button>
          <div className="collapse navbar-collapse" id="navbarMain">
            {isAuthenticated ? (
              <ul className="navbar-nav ml-auto">
                <li className="nav-item">
                  <a href="#!" className="nav-link">
                    {this.props.email}
                  </a>
                </li>
                <li className="nav-item">
                  <Link to="/" className="nav-link">
                    الملف الشخصي
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to={`/expertdomains/${expertid}`} className="nav-link">
                    مجالات الخبرة
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to={`/expertbooks/${expertid}`} className="nav-link">
                    المؤلفات
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to={`/expertresearchs/${expertid}`} className="nav-link">
                    البحوث والدراسات
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to={`/expertconferences/${expertid}`} className="nav-link">
                    المؤتمرات
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to={`/expertsupervisions/${expertid}`} className="nav-link">
                    الاشراف الاكاديمي
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to={`/expertprojects/${expertid}`} className="nav-link">
                    المشاريع
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to={`/expertconsultancies/${expertid}`} className="nav-link">
                    الخبرات الاستشارية
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to={`/expertcourses/${expertid}`} className="nav-link">
                    الدورات التدريبية
                  </Link>
                </li>
                <li className="nav-item">
                  <a
                    href="#!"
                    className="nav-link"
                    onClick={this.onLogoutClick}
                  >
                    تسجيل الخروج
                  </a>
                </li>
              </ul>
            ) : null}
            {!isAuthenticated ? (
              <ul className="navbar-nav ml-auto">
                <li className="nav-item">
                  <Link to="/login" className="nav-link">
                    تسجل الدخول
                  </Link>
                </li>
              </ul>
            ) : null}
          </div>
        </div>
      </nav>
    );
  }
}
export default AppNavbar;